




/* Created- 28 - Mar - 2019 */

import { Component, Vue, Prop } from "vue-property-decorator";

@Component(
	{
		name: "PageNotFound"
	})
export default class PageNotFound extends Vue {
}
